enum TransactionCategories {
  in_house_sales = 'in_house_sales',
  delivery = 'delivery',
  tips = 'tips',
  salary = 'salary',
  supply = 'supply',
  transfer = 'transfer',
}

export const transactionCategories = [
  TransactionCategories.in_house_sales,
  TransactionCategories.delivery,
  TransactionCategories.salary,
  TransactionCategories.supply,
  TransactionCategories.tips,
  TransactionCategories.transfer,
];

export default TransactionCategories;
